import { UserInfoResult } from '@/api/account'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { accountApi } from '@/api/account/index'

export const useUserInfoStore = defineStore('user', () => {
    const userInfo = ref<any>({})

    const initUserInfo = () => {
        return accountApi.getUserInfo().then((res) => {
            const { user_info } = res.data
            console.log('getUserInfo', res.data)
            if (user_info) {
                userInfo.value = user_info
            }
        })
    }
    const clearUserInfo = () => {
        userInfo.value = {}
    }
    const showUserCenter = ref(false)

    const setShowUserCenter = (val: boolean) => (showUserCenter.value = val)

    return {
        state: () => ({ userInfo }),
        userInfo: computed(() => userInfo.value),
        initUserInfo,
        showUserCenter,
        setShowUserCenter,
        clearUserInfo
    }
})
